// import SectionHeading from "./SectionHeading";
// import { Swiper, SwiperSlide } from "swiper/react";
// import { Navigation, Autoplay } from "swiper/modules";
// import "swiper/css";
// import "swiper/css/navigation";
// import "bootstrap/dist/css/bootstrap.min.css";
// import InvertedCommas from "../../Assets/Images/inverted_commas.png";
// import Arun from "../../Assets/Images/Dr_Arun_Kumar_Nayak.png";
// import Amish from "../../Assets/Images/Dr_Amish_Mhatre.png";
// import Hemant from "../../Assets/Images/Dr_Hemant_Joglekar.png";
// import Paresh from "../../Assets/Images/Dr_Paresh_Pai.png"; // Assuming you have an image for Dr. Paresh Pai

// const testimonials = [
//   {
//     quote:
//       "Our book launch was a big hit, thanks to their event planning and marketing strategies. They understood our field and delivered beyond expectations",
//     name: "Dr. Arun Kumar Nayak",
//     title: "Head, NCPW, DAE",
//     image: Arun, // Replace with actual image
//   },
//   {
//     quote:
//       "Exceptional execution and professionalism! The team managed our corporate conference flawlessly, ensuring a seamless experience for all attendees.",
//     name: "Dr. Amish Mhatre",
//     title: "Secretary Vessomag",
//     image: Amish, // Replace with actual image
//   },
//   {
//     quote:
//       "Attention to detail in our book publication event was outstanding. From venue selection to promotions, everything was perfectly handled. The event was well-organized, and the audience engagement was fantastic.",
//     name: "Dr. Hemant Joglekar",
//     title:
//       "Visiting Faculty at ICT (UDCT) & BARC Mumbai\nEx. Senior Manager, Asian Paints Ltd. HO, Mumbai",
//     image: Hemant,
//   },
//   {
//     quote:
//       "Despite having just a week to plan our first VESSOMAG annual conference, this team delivered with incredible professionalism. From venue selection to last-minute logistics, everything was flawlessly managed. The event ran seamlessly, and our core team called it the ‘best-organized event of the year.",
//     name: "Dr.Paresh Pai",
//     title:
//       "Chairman Vessomag",
//     image: Paresh,
//   },
// ];

// const TestimonialSection = () => {
//   return (
//     <section className="testimonial-section bg-white">
//       <div className="container-fluid text-center">
//         <Swiper
//           modules={[Navigation, Autoplay]}
//           navigation
//           loop
//           slidesPerView={1}
//           autoplay={{ delay: 2000 }}
//           speed={1000}
//           className="testimonial-swiper"
//         >
//           {testimonials.map((t, index) => (
//             <SwiperSlide key={index}>
//               <div>
//                 <div >
//                   <img src={InvertedCommas} alt="Inverted Commas" className="inverted-commas" />
//                 </div>
//                 <p className="py-4 px-3 text-black fw-light">{t.quote}</p>
//                 <img
//                   src={t.image}
//                   alt={t.name}
//                   className="rounded-circle my-3 testimonial-image"

//                 />
//                 <h3 >{t.name}</h3>
//                 <small className="d-block white-space-pre-line">
//                   {t.title}
//                 </small>
//               </div>
//             </SwiperSlide>
//           ))}
//         </Swiper>
//       </div>
//     </section>
//   );
// };
// function Testimonial() {
//   return (
//     <div>
//       <SectionHeading
//         secTitle="Testimonial"
//         secIndex="Get a glimpse of the transformative experience our event offers through the voices of past attendees"
//       />
//       <TestimonialSection />
//     </div>
//   );
// }

// export default Testimonial;

import { useEffect, useState } from "react";
import axios from "../../axios";
import SectionHeading from "./SectionHeading";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import InvertedCommas from "../../Assets/Images/inverted_commas.png";

const TestimonialSection = () => {
  const [testimonials, setTestimonials] = useState([]);

  useEffect(() => {
    axios
      .get("/testimonials")
      .then((res) => {
        // console.log("Fetched testimonials:", res.data);
        setTestimonials(res.data);
      })
      .catch((err) => {
        console.error("Failed to load testimonials", err);
      });
  }, []);

  // 🔒 Do not render anything if no testimonials
  if (testimonials.length === 0) return null;

  return (
    <>
      <SectionHeading
        secTitle="Testimonial"
        secIndex="Get a glimpse of the transformative experience our event offers through the voices of past attendees"
      />

      <section className="testimonial-section bg-white">
        <div className="container-fluid text-center">
          <Swiper
            modules={[Navigation, Autoplay]}
            navigation
            loop={testimonials.length > 1}
            slidesPerView={1}
            autoplay={{ delay: 2000 }}
            speed={1000}
            className="testimonial-swiper">
            {testimonials.map((t, index) => (
              <SwiperSlide key={index}>
                <div>
                  <div>
                    <img
                      src={InvertedCommas}
                      alt="Inverted Commas"
                      className="inverted-commas"
                    />
                  </div>
                  <p className="py-4 px-3 text-black fw-light">
                    {t.description}
                  </p>
                  <img
                    src={t.image_url}
                    alt={t.name}
                    className="rounded-circle my-3 testimonial-image"
                  />
                  <h3>{t.name}</h3>
                  <small className="d-block white-space-pre-line">
                    {t.designation}
                  </small>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </section>
    </>
  );
};
function Testimonial() {
  return (
    <div>
      <TestimonialSection />
    </div>
  );
}

export default Testimonial;
